import { defineMessages, IntlShape } from "react-intl";

import ActivityCompletion from "@mapmycustomers/shared/enum/activity/ActivityCompletion";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [ActivityCompletion.COMPLETE]: {
    id: "ActivityCompletion.complete",
    defaultMessage: '"Done"',
    description: "Label for default activity completion as Done",
  },
  [ActivityCompletion.INCOMPLETE]: {
    id: "ActivityCompletion.incomplete",
    defaultMessage: '"Not yet done"',
    description: "Label for default activity completion as Not yet done",
  },
});

const getActivityCompletionDisplayName = (
  intl: IntlShape,
  activityCompletion: ActivityCompletion
) => getDisplayName(intl, messages, activityCompletion, "ActivityCompletion");

export default getActivityCompletionDisplayName;
